import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import editbox from "../../Utils/Images/editbox.png";
import deletebox from "../../Utils/Images/deletebox.png";
import { Link } from "react-router-dom";
import CustomButton from "../Button/CustomButton";
import { handleDeleteCoupon } from "../../APIs/Function/Coupon/DeleteCoupon";
import DeleteModal from "../Modal/DeleteModal";
import { GetCoupon } from "../../APIs/Function/Coupon/GetCoupon";
import Loader from "../Loader/Loader";

const CouponTable = ({ setCouponData, couponData, loadinga }) => {
  const [modalID, setModalID] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    await handleDeleteCoupon(modalID);
    setLoading(false);
    setOpen(false);
    let res = await GetCoupon();
    setCouponData(res.r);
    alert("Coupon Deleted");
  };

  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {loading || loadinga ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box>
          {/* heading */}
          <Box
            sx={{
              boxShadow: "none",
              outline: "none",
              mb: "10px",
              border: "none",
              mt: "10px",
              boxSizing: "border-box",
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    #
                  </Typography>
                </Paper>
              </Grid>
              {/* Second Column */}
              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Coupon Code
                  </Typography>
                </Paper>
              </Grid>
              {/* Third Column */}
              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Coupon Description
                  </Typography>
                </Paper>
              </Grid>
              {/* Fourth Column */}
              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Discount Type
                  </Typography>
                </Paper>
              </Grid>
              {/* fifth Column */}
              <Grid item xs={2.5} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Discount Value
                  </Typography>
                </Paper>
              </Grid>
              {/* Sixth Column */}
              <Grid item xs={1.5} md={1.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                  border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                    // bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Action
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              border: "1px solid #DDDDDD",
              height: "100%",
              overflow: "auto",
              mt: "10px",
              borderTop: "0.5px solid #DDDDDD",
              maxHeight: "75vh",
            }}
          >
            <Box>
              <Grid container>
                {/* first column */}
                <Grid item xs={0.5} md={0.5}>
                  {couponData.map((item, i) => (
                    <Paper
                      sx={{
                    border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                      key={i}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                        }}
                      >
                        {i + 1}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>
                {/* Second Column */}
                <Grid item xs={2.5} md={2.5}>
                  {couponData.map((item, i) => (
                    <Paper
                      sx={{
                    border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={i}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                        }}
                      >
                        {item.coupon_code}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>
                {/* Third Column */}
                <Grid item xs={2.5} md={2.5}>
                  {couponData.map((item, i) => (
                    <Paper
                      sx={{
                        display: "flex",
                    border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        width: "100%",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={i}
                    >
                      <Tooltip title={item.description} arrow>
                        <Typography
                          noWrap
                          sx={{
                            cursor: "pointer",
                            m: "auto",
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            width: "200px",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.description}
                        </Typography>{" "}
                      </Tooltip>
                    </Paper>
                  ))}
                </Grid>
                {/* Fourth Column */}
                <Grid item xs={2.5} md={2.5}>
                  {couponData.map((item, i) => (
                    <Paper
                      sx={{
                        // boxSizing:"border-box",
                    border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={i}
                    >
                      <Button
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",

                          "&:hover": {
                            color:
                              item.discount_type === 1 ? "#ffffff" : "#636363",
                            bgcolor:
                              item.discount_type === 1 ? "#31AEF4" : "#E6E6E6",
                          },
                          color:
                            item.discount_type === 1 ? "#ffffff" : "#636363",
                          bgcolor:
                            item.discount_type === 1 ? "#31AEF4" : "#E6E6E6",
                        }}
                      >
                        {item.discount_type === 1 ? "Percentage" : "Price"}
                      </Button>
                    </Paper>
                  ))}
                </Grid>
                {/* fifth Column */}
                <Grid item xs={2.5} md={2.5}>
                  {couponData.map((item, i) => (
                    <Paper
                      sx={{
                    border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                      key={i}
                    >
                      <Typography
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          maxWidth: "90%",
                          "&:hover": {
                            overflow: "visible",
                          },
                        }}
                      >
                        {item.discount_type === 1
                          ? `${item.discount_value}%`
                          : `RS.${item.discount_value}`}
                      </Typography>
                    </Paper>
                  ))}
                </Grid>
                {/* Sixth Column */}
                <Grid item xs={1.5} md={1.5}>
                  {couponData.map((e, i) => (
                    <Paper
                      sx={{
                    border: "0.5px solid #DDDDDD",
                        borderRadius: "0px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        justifyContent: "center",
                        bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                      }}
                    >
                      <Box
                        sx={{
                          p: "5px",
                          display: "Flex",
                          width: "100%",
                          justifyContent: "center",
                          gap: "5px",
                        }}
                      >
                        <Box
                          sx={{
                            width: "25%",
                            cursor: "pointer",
                          }}
                        >
                          <img
                            width={"100%"}
                            src={deletebox}
                            alt=""
                            onClick={() => handleModal(e.id)}
                          />
                        </Box>
                        <Box
                          sx={{
                            width: "25%",
                            cursor: "pointer",
                          }}
                        >
                          <Link to={`/editcoupon/${e.id}`}>
                            <img width={"100%"} src={editbox} alt="" />
                          </Link>
                        </Box>
                      </Box>
                    </Paper>
                  ))}
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              mt: "25px",
              justifyContent: "end",
              width: "100%",
            }}
          >
            <Link to={"/addcoupon"}>
              <CustomButton
                sx={{
                  width: "100%",
                  bgcolor: "#31AEF4",
                  "&:hover": {
                    bgcolor: "#31AEF4",
                  },
                }}
              >
                ADD +
              </CustomButton>
            </Link>
          </Box>
        </Box>
      )}
      <DeleteModal
        open={open}
        handleDelete={handleDelete}
        modalID={modalID}
        onClose={handleClose}
      />
    </>
  );
};

export default CouponTable;
